import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import { styled } from "@mui/material/styles";
import { BodyTextM, BodyTextS, HeadingS } from "../Typography";
import robotImage from "../../../assets/images/robot.jpg";

export const ErrorTitle = styled(BodyTextM)(({ theme }) =>
    theme.unstable_sx({
        display: "inline-block",
        mb: 2,
    }),
);

export const ErrorInfoStack = styled(Stack)(({ theme }) =>
    theme.unstable_sx({
        gap: 4,
    }),
);

export const ErrorInfoHeading = styled(HeadingS)(({ theme }) =>
    theme.unstable_sx({
        m: 0,
    }),
);

export const ErrorInfoBox = styled(Box)(({ theme }) =>
    theme.unstable_sx({
        p: 3,
        borderRadius: 4,
        backgroundColor: theme.palette.grey.light,
    }),
);

export const ErrorInfoMessage = styled(BodyTextS)(({ theme }) =>
    theme.unstable_sx({
        m: 0,
    }),
);

export const ErrorContentStack = styled(Stack)(({ theme }) =>
    theme.unstable_sx({
        gap: 4,
        p: 4,
        maxWidth: { md: 450, xs: "unset" },
        mx: { md: "auto", xs: 0 },
        my: 4,
        flexGrow: 1,
        justifyContent: "center",
        minHeight: 450,
        backgroundImage: `url("${robotImage}")`,
        backgroundPosition: "right top",
        backgroundRepeat: "no-repeat",
        backgroundSize: "contain",
    }),
);

export const ErrorCard = styled(Paper)(({ theme }) =>
    theme.unstable_sx({
        overflow: "hidden",
    }),
);
